/**
 * Handle pluralization of strings, defaults to adding "s" suffix to provided initial word, and
 * returns the appropriate term based on count.
 *
 * @param word that is singular
 * @param count of units we are counting
 * @param multipleWord if provided, a replacement word for the plural form
 */
const pluralize = (
  word: string,
  count: number,
  multipleWord?: string,
): string => {
  if (Math.abs(count) === 1) {
    return word;
  }
  return multipleWord || `${word}s`;
};

export default pluralize;
